import { FormattedShopifyCollection } from '@portal/types/shopify/product.formatted.types';
import { RawShopifyCollection } from '@portal/types/shopify/product.raw.types';
import { reshapeToFormattedShopifyProduct } from './reshapeToFormattedShopifyProduct';

export const reshapeToFormattedShopifyCollection = (collection: RawShopifyCollection) => {
  return {
    ...collection,
    products: collection.products.nodes.map((product) => reshapeToFormattedShopifyProduct(product))
  } as FormattedShopifyCollection;
};
